import { Link } from "react-router-dom";
import { ArrowUpRight, Phone } from "lucide-react";
import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { Reveal } from "./Reveal";
import { CONTACT, QUOTE_PATH } from "../../lib/site";

export const CtaFinal = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const sunY = useTransform(scrollYProgress, [0, 1], ["40%", "-10%"]);
  return (
    <section ref={ref} data-testid="final-cta-section" className="relative overflow-hidden bg-forest-deep text-white">
      <motion.div aria-hidden="true" style={{ y: sunY }} className="pointer-events-none absolute -right-[20vw] top-0 h-[70vw] w-[70vw] rounded-full bg-gold/90 lg:-right-[10vw] lg:h-[46vw] lg:w-[46vw]" />
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 bg-[repeating-linear-gradient(0deg,transparent_0_38px,rgba(5,26,18,0.9)_38px_46px)] mix-blend-normal opacity-60" />
      <div className="container-x relative py-28 sm:py-36">
        <div className="max-w-3xl rounded-[2rem] bg-forest-deep/85 p-8 backdrop-blur-md sm:p-12">
          <Reveal><h2 className="font-display text-4xl font-semibold leading-[0.95] tracking-tight sm:text-5xl lg:text-6xl">Está preparado para aproveitar melhor a energia solar?</h2></Reveal>
          <Reveal delay={0.1}><p className="mt-6 max-w-xl text-base text-white/80 leading-relaxed md:text-lg">Partilhe connosco as suas necessidades e descubra que solução poderá fazer sentido para a sua casa ou empresa.</p></Reveal>
          <Reveal delay={0.2} className="mt-10 flex flex-col gap-3 sm:flex-row">
            <Link to={QUOTE_PATH} className="btn-gold group" data-testid="final-cta-quote-button">Solicitar Orçamento <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:rotate-45" /></Link>
            <a href={CONTACT.phoneHref} className="btn-ghost-light" data-testid="final-cta-call-button"><Phone className="h-4 w-4" /> {CONTACT.phoneDisplay}</a>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
